var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvmedLogoV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 60,
    viewBox: "0 0 116 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AvMed Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M92.4792 32.5205C92.4792 33.335 92.3102 33.8706 92.2378 34.5309H77.4375C78.1216 36.5707 80.2221 37.8548 82.4997 37.8548C84.0449 37.8548 85.735 37.3558 86.733 36.3506H91.7951C90.6603 39.5204 86.5318 41.9344 82.6365 41.9344C77.1639 41.9344 72.5846 37.8841 72.5846 32.7993C72.5846 27.4944 77.2363 23.4148 82.6768 23.4148C88.0689 23.4148 92.4792 27.6191 92.4792 32.5205ZM77.3651 30.8255H87.8677C87.2158 28.8518 85.0429 27.5017 82.6687 27.5017C80.2865 27.4944 78.0492 28.8811 77.3651 30.8255Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M115.191 18.1758V41.3693H110.99V38.9846C109.686 40.6135 107.585 41.9343 104.584 41.9343C99.0063 41.9343 95.1111 37.4144 95.1111 32.7405C95.1111 27.7217 99.3765 23.422 104.712 23.422C106.982 23.422 109.292 24.3319 110.603 25.8067V18.1758H115.191ZM99.6984 32.6084C99.6984 35.6241 102.25 37.8473 105.308 37.8473C108.374 37.8473 110.917 35.5214 110.917 32.6378C110.917 29.8129 108.27 27.4943 105.235 27.4943C102.073 27.4943 99.6984 30.0404 99.6984 32.6084Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.81853 18.095H14.7358L24.5302 41.3105H19.4922L17.4963 36.5265H7.10637L5.03803 41.3105H0L9.81853 18.095ZM12.3054 24.251L8.89302 32.2195H15.7016L12.3054 24.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.5605 24.1411H26.3813L31.1376 34.2741L35.886 24.1411H40.6745L32.6587 41.3106H29.5924L21.5605 24.1411Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M45.0847 18.095H49.8008L55.7081 34.2886L61.6636 18.095H66.3797L70.6532 41.3105H65.9692L63.241 26.6504L57.8247 41.3105H53.5593L48.1912 26.6504L45.3986 41.3105H40.6744L45.0847 18.095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M58.4927 4.09529C70.5647 4.05127 79.6106 10.0166 83.8519 19.0342C85.9846 19.4892 88.6002 20.986 89.9845 22.292C90.0167 22.3214 90.0408 22.3434 90.0649 22.3727C86.9182 10.0899 74.5082 0.918213 59.6677 0.918213C33.7533 0.918213 29.3027 22.2553 29.3027 22.2553C29.3027 22.2553 34.88 4.18334 58.4927 4.09529Z",
    fill: "#FFE558"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.387 45.7129C40.8757 52.3679 48.9961 56.8144 59.2573 56.8144C69.9208 56.8144 81.1719 52.4046 86.5882 45.2947L86.564 45.3167C80.8741 54.0409 70.2186 59.9181 58.0098 59.9181C45.4067 59.9181 34.4614 53.6593 28.9244 44.4656C28.9566 44.4803 28.9808 44.4949 29.013 44.5096C32.0792 45.8157 35.387 45.7129 35.387 45.7129Z",
    fill: "#FFE558"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvmedLogoV2);
export default __webpack_public_path__ + "static/media/avmed_logo_v2.cd0d51f09ddc9f120cfec6965192e1ed.svg";
export { ForwardRef as ReactComponent };